import { ForkEffect } from 'redux-saga/effects';

// eslint-disable-next-line no-empty-function
export function* watchModelsSagas(): Generator<ForkEffect, void> {}

const modelSagas = watchModelsSagas;
export default modelSagas;
